angular.module('CarsSaraBo').factory('GAService', function () {
	return {
		notify: function (category, action, args, value, fieldsObject) {
			try {
				if (fieldsObject == undefined || fieldsObject == null) {
					fieldsObject = {};
				}
				console.log("Sending GA statistics " + action +" - "+ this.listToString(args));
				ga('send', 'event', category, action, this.listToString(args), value, fieldsObject);
			} catch (error) {
				console.error("GA statistics could not be sent - " + error);
			}
		},

		listToString: function (args) {
			// returns args as strings concatenation
            return args ? args.join(', ') : 'default_label';
		}
	}
});



//////////////////
// WEBPACK FOOTER
// ./public/app/models/ga_service.js
// module id = 847
// module chunks = 3